<template>
  <BittsEmptyState
    class="api-tab-empty-state"
    :title="title"
    :font-awesome-icon="icon"
  >
    <template #subtitle>
      <p class="api-tab-empty-state__description">
        {{ description }}
      </p>
      <div class="api-tab-empty-state__actions">
        <BittsTooltip placement="bottom">
          <BittsButton
            :text="createCtaText"
            :left-icon="['fak', 'add']"
            :disabled="!!createDisabledReason"
            @click="emit('create')"
          />
          <template v-if="createDisabledReason" #title>
            {{ createDisabledReason }}
          </template>
        </BittsTooltip>
        <BittsButton
          text="API docs"
          type="neutral"
          :right-icon="['fak', 'external-link']"
          @click="handleDocsClick"
        />
      </div>
    </template>
  </BittsEmptyState>
</template>

<script setup lang="ts">
import { BittsButton, BittsEmptyState, BittsTooltip } from '@crossbeam/bitts';
import type { BittsIcon } from '@crossbeam/bitts';

import { API_DOCS_URL } from '../constants';

const { createDisabledReason = '' } = defineProps<{
  title: string;
  description: string;
  createCtaText: string;
  icon: BittsIcon;
  createDisabledReason?: string;
}>();

const emit = defineEmits<{
  create: [];
}>();

function handleDocsClick() {
  window.open(API_DOCS_URL, '_blank', 'noopener');
}
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";

.api-tab-empty-state {
  @apply flex-1;
}

.api-tab-empty-state__description {
  @apply text-neutral-text m-0 max-w-[420px];
}

.api-tab-empty-state__actions {
  @apply flex items-center justify-center gap-12 mt-24;
}
</style>
